import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Modal,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button,
  Typography
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NoteAttribution from './NoteAttribution';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 750,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  container: {
    maxHeight: 500
  },
  note: {
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0
    }
  },
  content: {
    marginTop: theme.spacing(1),
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  },
  noteActions: {
    marginTop: theme.spacing(1)
  }
}));

const NoteHistory = props => {
  const {
    open,
    notes,
    editable,
    deletable,
    onClose,
    onEdit,
    onDelete,
    className,
    ...rest
  } = props;

  const classes = useStyles();

  if (!open) {
    return null;
  }

  return (
    <Modal onClose={onClose} open={open}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardHeader title="Notes History" />
        <Divider />
        <CardContent>
          {notes.length === 0 ? (
            <Typography variant="body2">No notes recorded</Typography>
          ) : (
            <PerfectScrollbar className={classes.container}>
              {notes.map(note => (
                <div className={classes.note} key={note.id}>
                  <NoteAttribution note={note} />
                  <Typography className={classes.content} variant="body1">
                    {note.content}
                  </Typography>
                  {(editable || deletable) && (
                    <div className={classes.noteActions}>
                      {editable && (
                        <Button onClick={() => onEdit(note)} size="small">
                          Edit
                        </Button>
                      )}
                      {deletable && (
                        <Button onClick={() => onDelete(note)} size="small">
                          Delete
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </PerfectScrollbar>
          )}
        </CardContent>
        <CardActions className={classes.actions}>
          <Button onClick={onClose} variant="contained">
            Done
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

NoteHistory.propTypes = {
  className: PropTypes.string,
  deletable: PropTypes.bool,
  editable: PropTypes.bool,
  notes: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  open: PropTypes.bool
};

NoteHistory.defaultProps = {
  open: false,
  editable: false,
  deletable: false
};

export default NoteHistory;
